// extracted by mini-css-extract-plugin
export default {"layout":"index_layout_zJZkR","divider":"index_divider_QBl74","main":"index_main_TSqsm","content_list":"index_content_list_tt9hV","chip_item":"index_chip_item_mTBM1"};